import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { FiChevronLeft } from 'react-icons/fi';

// Actions
import { updateQueryString } from '../../../../services/router/actions';

// Workspaces
import { selectPreviousDate } from '../../selectors';

// Styles
import './styles.scss';

interface Props {
    updateQueryString: Function;
    previousDate: string;
}

export class DatePaginationButtonLeft extends React.Component<Props> {
    shouldComponentUpdate() {
        return false;
    }

    handleClick = () => {
        const { previousDate } = this.props;
        this.props.updateQueryString({
            date: previousDate,
            page: undefined
        });
    };

    render() {
        return (
            <button
                className="date-pagination-button-left"
                onClick={this.handleClick}
                type="button"
            >
                <FiChevronLeft size="22" style={{ height: 30 }} />
            </button>
        );
    }
}
const mapStateToProps = createStructuredSelector({
    previousDate: selectPreviousDate
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(DatePaginationButtonLeft);
